import { Link } from "react-router-dom";
import { Lock, Sparkles, ArrowRight } from "lucide-react";
import { Button } from "@/components/kit";

// Wraps a feature UI. When `active` (i.e. user lacks access), shows an upgrade
// banner and renders the UI underneath in a blurred, locked state.
export default function UpgradeGate({ active, feature = "Fitur ini", children }) {
  if (!active) return children;
  return (
    <div className="space-y-4" data-testid="upgrade-gate">
      <div className="flex items-center gap-3 rounded-xl border border-amber-200 bg-amber-50 px-4 py-3">
        <Sparkles className="w-5 h-5 text-amber-500 shrink-0" />
        <p className="text-sm text-amber-800 flex-1">
          <b>{feature}</b> hanya tersedia untuk paket berbayar. Upgrade untuk membukanya.
        </p>
        <Link to="/app/billing"><Button size="sm" data-testid="gate-upgrade-btn">Upgrade <ArrowRight className="w-4 h-4" /></Button></Link>
      </div>
      <div className="relative">
        <div className="pointer-events-none select-none blur-[2px] opacity-50">{children}</div>
        <div className="absolute inset-0 grid place-items-center">
          <div className="text-center bg-white/80 glass rounded-2xl px-8 py-6 border border-slate-200 shadow-lg">
            <div className="w-12 h-12 rounded-full bg-slate-900 grid place-items-center mx-auto mb-3">
              <Lock className="w-6 h-6 text-amber-400" />
            </div>
            <p className="font-display font-bold text-slate-800">Terkunci</p>
            <p className="text-sm text-slate-500 mt-1 mb-4 max-w-xs">Upgrade ke Starter untuk mulai menggunakan {feature.toLowerCase()}.</p>
            <Link to="/app/billing"><Button data-testid="gate-upgrade-cta">Lihat Paket <ArrowRight className="w-4 h-4" /></Button></Link>
          </div>
        </div>
      </div>
    </div>
  );
}
